export default "__VITE_ASSET__enihtHud__"